// extracted by mini-css-extract-plugin
var _1 = "NullState__NullState___CoDHp";
var _2 = "NullState__cta____vZHc";
var _3 = "NullState__subtitle___OnEho";
var _4 = "NullState__title___YzVDe";
var _5 = "NullState__wiggle___CNY7d";
export { _1 as "NullState", _2 as "cta", _3 as "subtitle", _4 as "title", _5 as "wiggle" }
